import ActionButton from 'lib/src/components/button/ActionButton';
import Form from '@components/form/Form';
import TextArea from '@components/form/TextArea';
import { useEffect, useState } from 'react';
import { AssessmentSummary } from 'src/types/shared/Assessments';
import useEditAssessment from './_hooks/useEditAssessment';
import Modal from '@components/modal/Modal';
import Title from 'lib/src/components/typography/Title';

const EditScoreSummaryCell = ({ row }: Props) => {
    const [showForm, setShowForm] = useState<boolean>(false);

    const {
        formState,
        handleChange,
        handleSubmit,
        isPosting,
        postError,
        postSuccess,
        prevSuccess,
    } = useEditAssessment(row);

    useEffect(() => {
        if (postSuccess && !prevSuccess) setShowForm(false);
    }, [prevSuccess, postSuccess]);

    if (showForm)
        return (
            <>
                <SummaryButton row={row} setShowForm={setShowForm} />
                <Modal closeModal={() => setShowForm(false)}>
                    <Title>{!row.submission.overallScoreSummary ? 'Add' : 'Edit'} Summary</Title>
                    <Form
                        error={postError}
                        onSubmit={handleSubmit}
                        onCancel={() => setShowForm(false)}
                        isPosting={isPosting}
                    >
                        <TextArea
                            name="summary"
                            value={formState.summary}
                            onChange={handleChange}
                            placeholder="Enter summary"
                            minRows={5}
                        />
                    </Form>
                </Modal>
            </>
        );

    return <SummaryButton row={row} setShowForm={setShowForm} />;
};

const SummaryButton: React.FC<SummaryButtonProps> = ({ row, setShowForm }) => (
    <ActionButton color="green" onClick={() => setShowForm(true)}>{`${
        !row.submission.overallScoreSummary ? 'Add' : 'Edit'
    } summary`}</ActionButton>
);

interface Props {
    row: AssessmentSummary;
}

interface SummaryButtonProps {
    row: AssessmentSummary;
    setShowForm: React.Dispatch<React.SetStateAction<boolean>>;
}

export default EditScoreSummaryCell;
